import { render, staticRenderFns } from "./c2c1c1PaymentLinkPage.vue?vue&type=template&id=8bec4932&scoped=true"
import script from "./c2c1c1PaymentLinkPage.vue?vue&type=script&lang=js"
export * from "./c2c1c1PaymentLinkPage.vue?vue&type=script&lang=js"
import style0 from "./c2c1c1PaymentLinkPage.vue?vue&type=style&index=0&id=8bec4932&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bec4932",
  null
  
)

export default component.exports